import React from "react";
import SText from "styled42/components/SText";

const ComponentHeader = props => (
  <SText containerStyle={props.style} size={24} color="primary" weight="bold">
    {props.title}
  </SText>
);

export default ComponentHeader;
